module.exports = __webpack_public_path__ + "static/media/1POLICY42.aa4c227a.jpg";